import { createContext, useContext } from 'react'
import RegisterStore from './RegisterStore'
import LocationsStore from './LocationStore'
import CarsStore from './CarsStore'
import CalendarStore from './CalendarStore'
import DescriptionStore from './DescriptionStore'
import BookingStore from './BookingStore'
import PaymentStore from './PaymentStore'
import FeedbackStore from './FeedbackStore'
import ProductsStore from './productStore'

export interface IStores {
  registerStore: RegisterStore;
  productsStore: ProductsStore;
  locationsStore: LocationsStore;
  carsStore: CarsStore;
  calendarStore: CalendarStore;
  descriptionStore: DescriptionStore;
  bookingStore: BookingStore;
  paymentStore: PaymentStore;
  feedbackStore: FeedbackStore;
}

class Stores implements IStores {
  registerStore = new RegisterStore()
  productsStore: ProductsStore = new ProductsStore(this)
  locationsStore: LocationsStore = new LocationsStore(this)
  calendarStore: CalendarStore = new CalendarStore(this)
  carsStore: CarsStore = new CarsStore(this)
  descriptionStore:DescriptionStore = new DescriptionStore(this)
  paymentStore:PaymentStore = new PaymentStore(this)
  bookingStore:BookingStore = new BookingStore(this)
  feedbackStore: FeedbackStore= new FeedbackStore(this)
}

export const stores = new Stores()

export const useStores = () : IStores => useContext(createContext(stores))
